import { useSelector } from 'react-redux';

const actorMetadataKeys = [
	'lastUpdatedBy',
	'lastUpdatedName',
	'createdBy',
	'createdName',
];

export const createCalendarMetadata = (
	metadata,
	user = {},
	now = new Date(),
) => {
	let reqMetadata = { ...(metadata || {}), lastUpdated: now };
	const isCaseManager = user.type === 'case-manager';

	if (!isCaseManager) {
		reqMetadata.lastUpdatedBy = user.id;
		reqMetadata.lastUpdatedName = `${user.firstname} ${user.lastname?.substring(
			0,
			1,
		)}`;
	}

	if (!metadata?.created) {
		reqMetadata.created = now;
		if (!isCaseManager) {
			reqMetadata.createdBy = user.id;
			reqMetadata.createdName = `${user.firstname} ${user.lastname?.substring(
				0,
				1,
			)}`;
		}
	}

	if (isCaseManager) {
		actorMetadataKeys.forEach((key) => delete reqMetadata[key]);
	}

	for (let key in reqMetadata) {
		if (!reqMetadata[key]) {
			delete reqMetadata[key];
		}
	}

	return reqMetadata;
};

export const useCreateMetadata = () => {
	const user = useSelector((state) => state.user.user);

	return (reqBody) => {
		return createCalendarMetadata(reqBody.metadata, user);
	};
};
